/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Refresh_In_One_Min_TitleInputs */

const en_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refreshing in a Minute or Less`)
};

const ar_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحديث خلال دقيقة أو أقل`)
};

const de_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisierung in spätestens einer Minute`)
};

const es_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización en un minuto o menos`)
};

const fr_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualisation dans une minute maximum`)
};

const it_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento entro un minuto`)
};

const ja_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分以内に更新`)
};

const ko_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1분 이내 새로고침`)
};

const pt_br_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização em até um minuto`)
};

const ru_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновление в течение минуты`)
};

const th_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีเฟรชภายในหนึ่งนาที`)
};

const tr_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir dakika içinde yenilenir`)
};

const zh_cn_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一分钟内刷新`)
};

const zh_tw_dialog_refresh_in_one_min_title = /** @type {(inputs: Dialog_Refresh_In_One_Min_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一分鐘內刷新`)
};

/**
* | output |
* | --- |
* | "Refreshing in a Minute or Less" |
*
* @param {Dialog_Refresh_In_One_Min_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_refresh_in_one_min_title = /** @type {((inputs?: Dialog_Refresh_In_One_Min_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Refresh_In_One_Min_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_refresh_in_one_min_title(inputs)
	if (locale === "ar") return ar_dialog_refresh_in_one_min_title(inputs)
	if (locale === "de") return de_dialog_refresh_in_one_min_title(inputs)
	if (locale === "es") return es_dialog_refresh_in_one_min_title(inputs)
	if (locale === "fr") return fr_dialog_refresh_in_one_min_title(inputs)
	if (locale === "it") return it_dialog_refresh_in_one_min_title(inputs)
	if (locale === "ja") return ja_dialog_refresh_in_one_min_title(inputs)
	if (locale === "ko") return ko_dialog_refresh_in_one_min_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_refresh_in_one_min_title(inputs)
	if (locale === "ru") return ru_dialog_refresh_in_one_min_title(inputs)
	if (locale === "th") return th_dialog_refresh_in_one_min_title(inputs)
	if (locale === "tr") return tr_dialog_refresh_in_one_min_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_refresh_in_one_min_title(inputs)
	return zh_tw_dialog_refresh_in_one_min_title(inputs)
});